import { Seo, breadcrumbJsonLd } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { EMAIL, PHONE } from "@/data/content";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Privacyverklaring", path: "/privacyverklaring" },
];

const H = ({ children }) => <h2 className="mt-10 font-heading text-base font-bold text-[#F5F7F9] md:text-lg">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-[#CBD3D9]/85">{children}</p>;

export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Privacyverklaring | Brandpreventie Recycling"
        description="Lees hoe Beveilig Alles B.V. omgaat met uw persoonsgegevens bij het gebruik van brandpreventierecycling.nl."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB)]}
      />
      <PageHeader overline="Juridisch" title="Privacyverklaring" breadcrumb={BREADCRUMB} />
      <section className="py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10" data-testid="privacy-content">
          <P>
            Deze privacyverklaring is van toepassing op de website brandpreventierecycling.nl, een
            gespecialiseerde oplossing van Beveilig Alles B.V. Wij gaan zorgvuldig om met uw
            persoonsgegevens en verwerken deze in overeenstemming met de Algemene Verordening
            Gegevensbescherming (AVG).
          </P>
          <H>Verwerkingsverantwoordelijke</H>
          <P>
            Beveilig Alles B.V. — telefoon: {PHONE}, e-mail: {EMAIL}, website: www.beveiligalles.nl.
          </P>
          <H>Welke gegevens verwerken wij?</H>
          <P>
            Wanneer u een offerte of locatieanalyse aanvraagt, verwerken wij de gegevens die u zelf
            invult: bedrijfsnaam, naam, functie, e-mailadres, telefoonnummer, adresgegevens,
            informatie over uw locatie en risicogebieden, en eventueel door u geüploade documenten
            zoals plattegronden of foto's. Daarnaast bewaren wij technische informatie over de
            herkomst van uw aanvraag (zoals de campagnebron en landingspagina).
          </P>
          <H>Waarvoor gebruiken wij uw gegevens?</H>
          <P>
            Uw gegevens worden uitsluitend gebruikt om uw aanvraag te beoordelen, contact met u op te
            nemen, een passend advies of offerte op te stellen en onze dienstverlening uit te voeren.
            Wij verkopen uw gegevens nooit aan derden.
          </P>
          <H>Grondslag van de verwerking</H>
          <P>
            Wij verwerken uw gegevens op basis van uw toestemming (bij het versturen van het
            formulier) en, wanneer een overeenkomst tot stand komt, op basis van de uitvoering van
            die overeenkomst.
          </P>
          <H>Bewaartermijn</H>
          <P>
            Wij bewaren aanvraaggegevens niet langer dan noodzakelijk voor het doel waarvoor ze zijn
            verzameld, tenzij een wettelijke bewaarplicht van toepassing is.
          </P>
          <H>Delen met derden</H>
          <P>
            Gegevens worden alleen gedeeld met partijen die noodzakelijk zijn voor de uitvoering van
            onze dienstverlening (zoals hosting- en e-maildienstverleners) en die passende
            beveiligingsmaatregelen hanteren.
          </P>
          <H>Beveiliging</H>
          <P>
            Wij nemen passende technische en organisatorische maatregelen om uw gegevens te
            beschermen tegen verlies of onrechtmatige verwerking, waaronder versleutelde
            verbindingen en beveiligde opslag.
          </P>
          <H>Uw rechten</H>
          <P>
            U heeft het recht op inzage, correctie, verwijdering, beperking van de verwerking,
            gegevensoverdraagbaarheid en het recht om bezwaar te maken. Ook kunt u een gegeven
            toestemming op ieder moment intrekken. Stuur uw verzoek naar {EMAIL}. U heeft daarnaast
            het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens.
          </P>
          <H>Cookies</H>
          <P>
            Voor informatie over het gebruik van cookies verwijzen wij naar onze cookieverklaring.
          </P>
          <H>Wijzigingen</H>
          <P>
            Deze privacyverklaring kan worden aangepast. De meest actuele versie vindt u altijd op
            deze pagina.
          </P>
        </div>
      </section>
    </>
  );
}
